// dailyPromo.config.ts

export type DailyPromoWeekday =
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";

export type DailyPromoLocalizedText = {
    en: string;
    es: string;
    "pt-br": string;
    id: string;
    th: string;
};

export type DailyPromoGameConfig = {
    appId: string;
    itemId: string;
    rawId: string;
    path: string;
    thumbnailUrl: string;
    title: DailyPromoLocalizedText;
    subtitle: DailyPromoLocalizedText;
};

const _unGamePromo = {
    appId: "app_ca7d2b3ff46067131f51586e59b50900",
    itemId: "d25e61ec-32cc-489a-982b-2f3254147098",
    rawId: "un_daily",
    path: "/?ref=eh",
    thumbnailUrl: "https://media.bridge.cm/un-app-icon-1.webp",
    title: {
        en: "GAME OF THE DAY!",
        es: "¡JUEGO DEL DÍA!",
        "pt-br": "JOGO DO DIA!",
        id: "GAME HARI INI!",
        th: "เกมประจำวัน!",
    },
    subtitle: {
        en: "Earn Coins By Playing!",
        es: "¡Gana monedas jugando!",
        "pt-br": "Ganhe moedas jogando!",
        id: "Dapatkan Koin dengan Bermain!",
        th: "รับเหรียญจากการเล่น!",
    },
} satisfies DailyPromoGameConfig;
const _pjGamePromo = {
    appId: "app_cf9dace7b0104a6a151e4e26c649de3b",
    itemId: "9f50041b-9adb-4077-aab6-d49702cb7966",
    rawId: "pj_daily",
    path: "/?ref=eh",
    thumbnailUrl: "https://media.bridge.cm/pj-app-icon.webp",
    title: {
        en: "GAME OF THE DAY!",
        es: "¡JUEGO DEL DÍA!",
        "pt-br": "JOGO DO DIA!",
        id: "GAME HARI INI!",
        th: "เกมประจำวัน!",
    },
    subtitle: {
        en: "Earn Coins By Playing!",
        es: "¡Gana monedas jugando!",
        "pt-br": "Ganhe moedas jogando!",
        id: "Dapatkan Koin dengan Bermain!",
        th: "รับเหรียญจากการเล่น!",
    },
} satisfies DailyPromoGameConfig;
const _mwGamePromo = {
    appId: "app_cc9e631ad8d8936d6a4b34a403689279",
    itemId: "239cf626-67ad-4881-a8ed-6551862095d2",
    rawId: "mw_daily",
    path: "/?ref=eh",
    thumbnailUrl: "https://media.bridge.cm/mw-icon.webp",
    title: {
        en: "GAME OF THE DAY!",
        es: "¡JUEGO DEL DÍA!",
        "pt-br": "JOGO DO DIA!",
        id: "GAME HARI INI!",
        th: "เกมประจำวัน!",
    },
    subtitle: {
        en: "Earn Coins By Playing!",
        es: "¡Gana monedas jugando!",
        "pt-br": "Ganhe moedas jogando!",
        id: "Dapatkan Koin dengan Bermain!",
        th: "รับเหรียญจากการเล่น!",
    },
} satisfies DailyPromoGameConfig;
const _bbGamePromo = {
    appId: "app_911d07e15674a4450a3a749ea7eb502b",
    itemId: "a314a029-b8b7-4968-8e6e-cb268e86f13c",
    rawId: "bb_daily",
    path: "/?ref=eh",
    thumbnailUrl: "https://media.bridge.cm/bb-app-icon.webp",
    title: {
        en: "GAME OF THE DAY!",
        es: "¡JUEGO DEL DÍA!",
        "pt-br": "JOGO DO DIA!",
        id: "GAME HARI INI!",
        th: "เกมประจำวัน!",
    },
    subtitle: {
        en: "Earn Coins By Playing!",
        es: "¡Gana monedas jugando!",
        "pt-br": "Ganhe moedas jogando!",
        id: "Dapatkan Koin dengan Bermain!",
        th: "รับเหรียญจากการเล่น!",
    },
} satisfies DailyPromoGameConfig;
const _cjGamePromo = {
    appId: "app_16603dd89b5aaa23c802002c0d430b1e",
    itemId: "99d5efb7-0227-4b66-bd79-e59fe9084542",
    rawId: "cj_daily",
    path: "/?ref=eh",
    thumbnailUrl: "https://media.bridge.cm/cj-app-icon-1.webp",
    title: {
        en: "GAME OF THE DAY!",
        es: "¡JUEGO DEL DÍA!",
        "pt-br": "JOGO DO DIA!",
        id: "GAME HARI INI!",
        th: "เกมประจำวัน!",
    },
    subtitle: {
        en: "Earn Coins By Playing!",
        es: "¡Gana monedas jugando!",
        "pt-br": "Ganhe moedas jogando!",
        id: "Dapatkan Koin dengan Bermain!",
        th: "รับเหรียญจากการเล่น!",
    },
} satisfies DailyPromoGameConfig;

export const dailyPromoSchedule = {
    monday: _unGamePromo,
    tuesday: _pjGamePromo,
    wednesday: _mwGamePromo,
    thursday: _bbGamePromo,
    friday: _cjGamePromo,
    saturday: _mwGamePromo,
    sunday: _cjGamePromo,
} satisfies Record<DailyPromoWeekday, DailyPromoGameConfig>;
